import { render, staticRenderFns } from "./RecetasModificadores.vue?vue&type=template&id=86970076&"
import script from "./RecetasModificadores.vue?vue&type=script&lang=js&"
export * from "./RecetasModificadores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports